const HiddenField = () => null;

export { HiddenField };
